var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unroll-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-Password---1",
    transform: "translate(-812.000000, -416.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-1",
    transform: "translate(570.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-in-AOL",
    transform: "translate(131.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.147942,17.4541612 C116.060442,17.5416615 115.929191,17.5999951 115.797941,17.5999951 L112.181262,17.5999951 C111.991678,17.5999951 111.816677,17.4979114 111.74376,17.3229108 C111.714593,17.2645772 111.70001,17.1916603 111.70001,17.1333268 C111.70001,17.0166597 111.74376,16.914576 111.816677,16.8270757 L116.381276,11.9999754 L111.816677,7.18745846 C111.70001,7.04162461 111.65626,6.85204061 111.74376,6.67704 C111.816677,6.51662277 111.991678,6.39995569 112.181262,6.39995569 L115.797941,6.39995569 C115.929191,6.39995569 116.060442,6.45828923 116.147942,6.56037292 L120.902126,11.6937243 C121.077126,11.8687249 121.077126,12.1312258 120.902126,12.3208098 L116.147942,17.4541612 Z",
    id: "n"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.0c3f0205213682bec37a6f53c4054c2a.svg";
export { ForwardRef as ReactComponent };